import { FormikProps } from "formik";
import PriceBreakdown from "../../components/purchase/PriceBreakdown";
import { ICFormikTextInput } from "../../core-component/formik";
import UseTranslationHook from "../../hooks/UseTranslationHook";
import { CURRENCY_SIGN } from "../../utils/AppConstants";
import { prepareMessageFromParams } from "../../utils/AppFunctions";
import { checkPrice } from "../../utils/PriceCalculator";
import { PRICE_CHECK_STATUS_ENUM } from "../../utils/PurchaseEnumerations";
import { formatAmountWithSign } from "../../utils/PurchaseFormat";
import { IPackageEditorForm } from "./PackageEditorController";

interface IPackagePriceTabProps {
  formikProps: FormikProps<IPackageEditorForm>;
  isFreeTrial: boolean;
  readOnly: boolean;
}

const PackagePriceTab: React.FC<IPackagePriceTabProps> = ({
  formikProps,
  isFreeTrial,
  readOnly,
}) => {
  const { t } = UseTranslationHook();
  const { values } = formikProps;

  if (isFreeTrial) {
    return (
      <div className="text-sm text-muted">
        {prepareMessageFromParams(t("free_trial_price_hint"), [["currency", CURRENCY_SIGN]])}
      </div>
    );
  }

  const rates = { cgst: values.cgst, sgst: values.sgst, igst: values.igst };
  const check = checkPrice(values.base_price, rates);
  const disabled = readOnly;

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        <ICFormikTextInput
          {...formikProps}
          fieldName="base_price"
          placeholder={prepareMessageFromParams(t("base_price_rupees"), [["currency", CURRENCY_SIGN]])}
          type="number"
          step="0.01"
          disabled={disabled}
          required
        />
        <ICFormikTextInput
          {...formikProps}
          fieldName="cgst"
          placeholder={t("cgst_percentage")}
          type="number"
          step="0.01"
          disabled={disabled}
          required
        />
        <ICFormikTextInput
          {...formikProps}
          fieldName="sgst"
          placeholder={t("sgst_percentage")}
          type="number"
          step="0.01"
          disabled={disabled}
          required
        />
        <ICFormikTextInput
          {...formikProps}
          fieldName="igst"
          placeholder={t("igst_percentage")}
          type="number"
          step="0.01"
          disabled={disabled}
          required
        />
      </div>
      <PriceBreakdown basePrice={values.base_price} rates={rates} />
      <div className="bg-base rounded-md p-3 flex justify-between">
        <span className="text-sm text-muted">{t("total_calculated")}</span>
        <span className="font-semibold">
          {check.status === PRICE_CHECK_STATUS_ENUM.Valid
            ? formatAmountWithSign(check.breakdown.total_paise / 100)
            : "-"}
        </span>
      </div>
      <div className="text-sm text-muted">{t("price_changes_new_orders_only")}</div>
    </div>
  );
};

export default PackagePriceTab;
